import { render, staticRenderFns } from "./UpcomingHolidays.vue?vue&type=template&id=1f55813d"
import script from "./UpcomingHolidays.vue?vue&type=script&lang=js"
export * from "./UpcomingHolidays.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports